<template>
  <v-bottom-navigation
    class="bottom-navigation-bar"
    grow
    light
  >
    <v-btn to="/home">
      <span>Home</span>

      <!-- <v-icon color="#37474F">
        mdi-home-variant
      </v-icon> -->
      <img
        src="../../assets/img/home_icon.png"
        alt=""
        width="24"
      >
    </v-btn>
    <v-btn
      v-if="anyUserOrganizationAvailable && userData.active && userData.app_user_role === 'site-manager'"
      to="/reports"
    >
      <span>Reports</span>
      <img
        src="../../assets/img/report.png"
        alt=""
        width="24"
      >
    </v-btn>
    <!-- <v-btn  v-if="anyUserOrganizationAvailable && userData.app_user_role !== 'site-manager'" to="/jobs">
      <span>Schedule</span>
      <img
        src="../../assets/img/schedule.png"
        alt=""
        width="24"
      >
    </v-btn> -->
    <v-btn
      v-if="anyUserOrganizationAvailable"
      to="/timesheets"
    >
      <span>Timesheets</span>
      <img
        src="../../assets/img/timesheet.png"
        alt=""
        width="24"
      >
    </v-btn>
    <!-- <v-btn
      v-if="anyUserOrganizationAvailable && !userData.timesheet_tracking"
      to="/activity"
    >
      <span>Activities</span>
      <img
        src="../../assets/img/timesheet.png"
        alt=""
        width="24"
      >
    </v-btn> -->
    <v-btn to="/profile">
      <span>Profile</span>
      <img
        src="../../assets/img/profile_icon.png"
        alt=""
        width="24"
      >
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    userData () {
      return this.$store.getters.getSelectedOrganization;
    },
    anyUserOrganizationAvailable () {
      if (this.userOrganizations.length === 0) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.flip-icon {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.bottom-navigation-bar {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  z-index: 99 !important;
}
</style>
